import { css } from '@emotion/react';
import { ViewerFont, ViewerFontFileName } from '@diritto/common/viewer/constants/viewer.constant';
import { Font } from 'constants/contentCover';
import { configure } from 'utils/configure';

export const fonts = css`
  // Pretendard
  @font-face {
    font-family: 'Pretendard';
    font-weight: 900;
    font-display: optional;
    src:
      url('${configure.staticPrefix}/fonts/Pretendard/woff2-subset/Pretendard-Black.subset.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Pretendard/woff-subset/Pretendard-Black.subset.woff') format('woff');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 800;
    font-display: optional;
    src:
      url('${configure.staticPrefix}/fonts/Pretendard/woff2-subset/Pretendard-ExtraBold.subset.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Pretendard/woff-subset/Pretendard-ExtraBold.subset.woff') format('woff');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 700;
    font-display: optional;
    src:
      url('${configure.staticPrefix}/fonts/Pretendard/woff2-subset/Pretendard-Bold.subset.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Pretendard/woff-subset/Pretendard-Bold.subset.woff') format('woff');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 600;
    font-display: optional;
    src:
      url('${configure.staticPrefix}/fonts/Pretendard/woff2-subset/Pretendard-SemiBold.subset.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Pretendard/woff-subset/Pretendard-SemiBold.subset.woff') format('woff');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 500;
    font-display: optional;
    src:
      url('${configure.staticPrefix}/fonts/Pretendard/woff2-subset/Pretendard-Medium.subset.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Pretendard/woff-subset/Pretendard-Medium.subset.woff') format('woff');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 400;
    font-display: optional;
    src:
      url('${configure.staticPrefix}/fonts/Pretendard/woff2-subset/Pretendard-Regular.subset.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Pretendard/woff-subset/Pretendard-Regular.subset.woff') format('woff');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 300;
    font-display: optional;
    src:
      url('${configure.staticPrefix}/fonts/Pretendard/woff2-subset/Pretendard-Light.subset.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Pretendard/woff-subset/Pretendard-Light.subset.woff') format('woff');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 200;
    font-display: optional;
    src:
      url('${configure.staticPrefix}/fonts/Pretendard/woff2-subset/Pretendard-ExtraLight.subset.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Pretendard/woff-subset/Pretendard-ExtraLight.subset.woff') format('woff');
  }

  @font-face {
    font-family: 'Pretendard';
    font-weight: 100;
    font-display: optional;
    src:
      url('${configure.staticPrefix}/fonts/Pretendard/woff2-subset/Pretendard-Thin.subset.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Pretendard/woff-subset/Pretendard-Thin.subset.woff') format('woff');
  }

  // YESMyoungjo
  @font-face {
    font-family: ${Font.YESMyoungjo};
    src:
      url('${configure.staticPrefix}/fonts/YESMyoungjo/YES24MyoungjoR.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/YESMyoungjo/YES24MyoungjoR.otf') format('opentype');
    font-display: block;
  }

  // HSBomBaram = 'HSBomBaram',
  @font-face {
    font-family: ${Font.HSBomBaram};
    src:
      url('${configure.staticPrefix}/fonts/HSBomBaram/HSBomBaram.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/HSBomBaram/HSBomBaram.otf') format('opentype');
    font-display: block;
  }

  // Cafe24ClassicType = 'Cafe24ClassicType',
  @font-face {
    font-family: ${Font.Cafe24ClassicType};
    src:
      url('${configure.staticPrefix}/fonts/Cafe24ClassicType/Cafe24ClassicType.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Cafe24ClassicType/Cafe24ClassicType.ttf') format('truetype'),
      url('${configure.staticPrefix}/fonts/Cafe24ClassicType/Cafe24ClassicType.otf') format('opentype');
    font-display: block;
  }

  // HancomMalangMalang = 'HancomMalangMalang',
  @font-face {
    font-family: ${Font.HancomMalangMalang};
    src:
      url('${configure.staticPrefix}/fonts/HancomMalangMalang/HancomMalangMalang.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/HancomMalangMalang/HancomMalangMalang.ttf') format('truetype'),
      url('${configure.staticPrefix}/fonts/HancomMalangMalang/HancomMalangMalang.otf') format('opentype');
    font-display: block;
  }

  // TlabShinYB = 'TlabShinYB',
  @font-face {
    font-family: ${Font.TlabShinYB};
    src:
      url('${configure.staticPrefix}/fonts/TlabShinYB/TlabShinYB.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/TlabShinYB/TlabShinYB.otf') format('opentype');
    font-display: block;
  }

  // Danjo = 'Danjo',
  @font-face {
    font-family: ${Font.Danjo};
    src:
      url('${configure.staticPrefix}/fonts/Danjo/Danjo.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Danjo/Danjo.otf') format('opentype');
    font-display: block;
  }

  // BookkMyungjo = 'BookkMyungjo',
  @font-face {
    font-family: ${Font.BookkMyungjo};
    src: url('${configure.staticPrefix}/fonts/BookkMyungjo/BookkMyungjo_Light.woff2') format('woff2');
    font-display: block;
  }

  // Warhaven = 'Warhaven',
  @font-face {
    font-family: ${Font.Warhaven};
    src: url('${configure.staticPrefix}/fonts/Warhaven/Warhaven.woff2') format('woff2');
    font-display: block;
  }

  // Base viewer fonts
  @font-face {
    font-family: ${ViewerFont.RidiBatang};
    src:
      url('${configure.staticPrefix}/fonts/Viewer/${ViewerFontFileName[ViewerFont.RidiBatang]}.woff2') format('woff2'),
      url('${configure.staticPrefix}/fonts/Viewer/${ViewerFontFileName[ViewerFont.RidiBatang]}.otf') format('opentype');
    font-display: block;
  }
`;
